/* eslint @typescript-eslint/no-explicit-any: 0 */
export class InvoiceDistributionResponseModel implements IInvoiceDistributionResponseModel {
  finished?: boolean;
  message?: string;
  current?: number | undefined;
  total?: number | undefined;
  failedEmails?: number | undefined;

  constructor(data?: IInvoiceDistributionResponseModel) {
    if (data) {
      for (const property in data) {
        if (Object.hasOwn(data, property)) (this as any)[property] = (data as any)[property];
      }
    }
  }
}

export interface IInvoiceDistributionResponseModel {
  finished?: boolean;
  message?: string;
  current?: number | undefined;
  total?: number | undefined;
  failedEmails?: number | undefined;
}
